<div class="portfolio-view" *ngIf="portfolio != null">
  <div class="row details-head">
    <div class="portfolio-name">
      <hr-portfolio-edit-name
        *ngIf="portfolio != null"
        [portfolio]="portfolio"
        (onEdit)="onEditPortfolioNameClick($event)"
        (onUpdate)="onUpdatePortfolioNameClick($event)"
      ></hr-portfolio-edit-name>
      <div class="create-date">
        {{ 'label.CreateDate' | translate }}: {{ portfolio?.createDate }}
      </div>
    </div>
    <div class="sales-assistant">
      <app-portfolio-add-sales-assistant
        [portfolio]="portfolio"
      ></app-portfolio-add-sales-assistant>
    </div>
    <div class="account-manager">
      {{ 'AccountManager' | i18nLabel }}:
      <hr-portfolio-edit-account-manager
        *ngIf="portfolio != null"
        [portfolio]="portfolio"
        (onEdit)="onEditAccountManagerClick($event)"
        (onUpdate)="onPortfolioAccountManagerUpdated($event)"
      >
      </hr-portfolio-edit-account-manager
      ><br />
      <hr-portfolio-view-history
        *ngIf="portfolio != null"
        [portfolio]="portfolio"
        [display]="displayViewHistory"
        (onClick)="onPortfolioViewHistoryClick($event)"
        (onClose)="onCloseViewHistoryClick($event)"
      >
      </hr-portfolio-view-history>
    </div>
  </div>
  <hr-portfolio-customer-details
    *ngIf="portfolio != null"
    [portfolio]="portfolio"
  ></hr-portfolio-customer-details>
</div>
